const BakeryGoogleMaps = () => {
  return (
    <div className="BakeryGoogleMaps d-block mx-auto position-relative ">
      <div className="BakeryGoogleMaps_gMapsTitle position-absolute start-50 px-3 py-2 translate-middle btn-color-design1-hover">
        OUR LOCATION
      </div>
      <div className="BakeryGoogleMaps_gMapsLogo position-absolute rounded-circle overflow-hidden top-0 end-0 m-2">
        <img
          src="./img/logo_noree.jpg"
          width="80"
          height="80"
          alt="BakeryGoogleMapsLogo"
        />
      </div>
      <div className="BakeryGoogleMaps_gMaps d-flex justify-content-center align-items-center">
        <p>Google Maps Loading...</p>
        <iframe title={"Google Maps of Noree's Sweet Dough & Batter"} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3864.1884039722913!2d120.9187073104618!3d14.416300185990334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3397d30cd714a9cb%3A0x32ba8dcdcb5aebab!2sNOREE&#39;S%20SWEET%20DOUGH%20%26%20BATTER!5e0!3m2!1sen!2sau!4v1771161833848!5m2!1sen!2sau" width="100%" allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </div>
  );
};

export default BakeryGoogleMaps;
